<template>
  <div class="number-field">
    <input type="number"  @keyup="emitValue()" @keyup.enter="emitValue()" v-model="value">
    <span class="btn-plus" @click="increaseOrDecrease('increase')"><span>+</span></span>
    <span class="btn-moins" @click="increaseOrDecrease('decrease')"><span>-</span></span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: 1,
      timer: null,
    }
  },
  props: {
    val: {
      type: Number,
      default: 1
    },
    immediate: {
      type: Boolean,
      default: true
    }
  },
  created() {

    

    if(this.value < 0) {
      this.value = 0
    } else {
      this.value = this.$props.val;
    }

    if(this.$props.immediate) {
      this.emitValue();
    }
  },
  methods: {
    emitValue(mode) {

      if(mode === 'direct') {

        if(this.value < 0) {
          this.value = 0;
        }

        this.$emit('update-value', Number(this.value));

      } else {

        clearTimeout(this.timer);
  
        this.timer = setTimeout(() => {
  
          if(this.value < 0) {
            this.value = 0;
          }
  
          this.$emit('update-value', Number(this.value));
      
        }, 500);
      }
    },
    delay(callback, ms) {

      var timer = 0;

      return function() {

        var context = this, args = arguments;

        clearTimeout(timer);

        timer = setTimeout(function () {

          callback.apply(context, args);

        }, ms || 0);
      };
    },
    increaseOrDecrease(sType) {
      if (sType === 'decrease') {
        if (this.value > 1) {
          this.value--;
        }
      } else {
        this.value++
      }
      this.emitValue('direct');
    }
  },
  watch: {
    val(val) {
      this.value = val
    }
  }
}
</script>

<style scoped>
.number-field {
  position: relative;
  color: gray;
  margin: 10px;
  width: 120px;
}
.btn-plus, .btn-moins {
  position: absolute;
  top: 10px;
  border: solid gray 1px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.btn-plus span, .btn-moins span {
  font-size: 1rem;
}
.btn-plus {
  right: 35px;
}
.btn-moins {
  right: 10px;
}
.number-field input[type="number"] {
  width: 100%;
  color: gray;
  min-width: 120px;
}
</style>